export default "__VITE_ASSET__ryXR4xO7__"